import {Component, OnInit, ViewChild} from '@angular/core';
import { Settings } from '../../services/settings';
import {GeneralsettingsComponent} from "./generalsettings/generalsettings.component";
import {BannerComponent} from "./generalsettings/settingsections/banner/banner.component";

@Component({
	selector: 'app-settings',
	templateUrl: './settings.component.html',
	styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

	visibleAgencyManagement: boolean = false;
	visibleUserManagement: boolean = false;
	visibleSecurityGroupManagement: boolean = false;

	visibleRequestTypeManagement: boolean = false;
	visibleRequestStatusManagement: boolean = false;
	visibleRegionsManagement: boolean = false;
	visibleStatusReasonsManagement: boolean = false;
	visibleUnitOfMeasureManagement: boolean = false;
	visibleNoteCategoryManagement: boolean = false;
	visibleDocumentCategoryManagement: boolean = false;
	visibleMessageDefinitionManagement: boolean = false;
	visibleQualificationsMasterManagement: boolean = false;
	visibleRelationshipTypesManagement: boolean = false;
	visibleAutomatedEmailsManagement: boolean = false;
	visibleGeneralSettings: boolean = false;
	visibleEmailSettings: boolean = false;
	visibleSecurityTargetSettings: boolean = false;

	visibleAgencyLink: boolean = false;
	visibleUserLink: boolean = false;
	visibleSecurityGroupLink: boolean = false;

	visibleRequestStatusLink: boolean = false;
	visibleRequestTypeLink: boolean = false;
	visibleRegionsLink: boolean = false;
	visibleStatusReasonsLink: boolean = false;
	visibleUnitOfMeasureLink: boolean = false;
	visibleNoteCategoryLink: boolean = false;
	visibleDocumentCategoryLink: boolean = false;
	visibleQualificationsMasterLink: boolean = false;
	visibleRelationshipTypesMasterLink: boolean = false;

	visibleMessageDefinitionLink: boolean = false;
	visibleAutomatedEmailsLink: boolean = false;
	visibleSecurityTargetLink: boolean = false;

	visibleGeneralLink: boolean = false;
	visibleEmailLink: boolean = false;

	@ViewChild('banner', {static: true}) banner: BannerComponent;
	constructor() { }

	ngOnInit() {

		if (Settings.getInstance().hasPrivilege('SETTINGS_AGENCY', "READ")) {
			this.visibleAgencyLink = true;
		}
		if (Settings.getInstance().hasPrivilege('SETTINGS_USERS', "READ")) {
			this.visibleUserLink = true;
		}
		if (Settings.getInstance().hasPrivilege('SETTINGS_GROUP_MANAGEMENT', "READ")) {
			this.visibleSecurityGroupLink = true;
		}
		if (Settings.getInstance().hasPrivilege('SECURITY_TARGETS', "READ")) {
			this.visibleSecurityTargetLink = true;
		}
		if (Settings.getInstance().hasPrivilege('SETTINGS_REQUEST_TYPES', "READ")) {
			this.visibleRequestTypeLink = true;
		}
		if (Settings.getInstance().hasPrivilege('SETTINGS_REQUEST_STATUSES', "READ")) {
			this.visibleRequestStatusLink = true;
		}
		if (Settings.getInstance().hasPrivilege('SETTINGS_REGIONS', "READ")) {
			this.visibleRegionsLink = true;
		}
		if (Settings.getInstance().hasPrivilege('SETTINGS_STATUS_REASONS', "READ")) {
			this.visibleStatusReasonsLink = true;
		}
		if (Settings.getInstance().hasPrivilege('SETTINGS_UNIT_OF_MEASURE', "READ")) {
			this.visibleUnitOfMeasureLink = true;
		}
		if (Settings.getInstance().hasPrivilege('SETTINGS_NOTE_CATEGORIES', "READ")) {
			this.visibleNoteCategoryLink = true;
		}	
		if (Settings.getInstance().hasPrivilege('SETTINGS_DOCUMENT_CATEGORIES', "READ")) {
			this.visibleDocumentCategoryLink = true;
		}
		if (Settings.getInstance().hasPrivilege('SETINGS_MASTER_QUALIFICATIONS', "READ")) {
			this.visibleQualificationsMasterLink = true;
		}
		if (Settings.getInstance().hasPrivilege('SETTINGS_RELATIONSHIP_TYPES', "READ")) {
			this.visibleRelationshipTypesMasterLink = true;
		}
		if (Settings.getInstance().hasPrivilege('SETTINGS_MESSAGE_TEMPLATES', "READ")) {
			this.visibleMessageDefinitionLink = true;
		}
		if (Settings.getInstance().hasPrivilege('SETTINGS_AUTOMATED_EMAILS', "READ")) {
			this.visibleAutomatedEmailsLink = true;
		}	
		if (Settings.getInstance().hasPrivilege('SETTINGS_EMAIL_SETTINGS', "READ")) {
			this.visibleEmailLink = true;
		}
		if (Settings.getInstance().hasPrivilege('NAV_GENERAL_SETTINGS', "READ")) {
			this.visibleGeneralLink = true;
		}
	}
	public showAgencyManagement() {
		this.hideAllChildComponents();
		this.addClassToItem('agencyItem');
		this.visibleAgencyManagement = true;
	}
	public showUserManagement() {
		this.hideAllChildComponents();
		this.addClassToItem('userItem');
		this.visibleUserManagement = true;
	}
	public showSecurityGroupManagement() {
		this.hideAllChildComponents();
		this.addClassToItem('groupMgmtItem');
		this.visibleSecurityGroupManagement = true;
	}
	public showRequestTypes() {
		this.hideAllChildComponents();
		this.addClassToItem('requestTypeItem');
		this.visibleRequestTypeManagement = true;
	}
	public showRequestStatus() {
		this.hideAllChildComponents();
		this.addClassToItem('requestStatusItem');
		this.visibleRequestStatusManagement = true;
	}
	public showMasterRegions() {
		this.hideAllChildComponents();
		this.addClassToItem('masterRegionsItem');
		this.visibleRegionsManagement = true;
	}
	public showStatusReasons() {
		this.hideAllChildComponents();
		this.addClassToItem('statusReasonsItem');
		this.visibleStatusReasonsManagement = true;
	}
	public showUnitOfMeasure() {
		this.hideAllChildComponents();
		this.addClassToItem('unitOfMeasureItem');
		this.visibleUnitOfMeasureManagement = true;
	}
	public showNoteCategory() {
		this.hideAllChildComponents();
		this.addClassToItem('noteCategoryItem');
		this.visibleNoteCategoryManagement = true;
	}

	public showDocumentCategory() {
		this.hideAllChildComponents();
		this.addClassToItem('documentCategoryItem');
		this.visibleDocumentCategoryManagement = true;
	}
	public showMessageDefinitions() {
		this.hideAllChildComponents();
		this.addClassToItem('messageDefinitionItem');
		this.visibleMessageDefinitionManagement = true;
	}
	public showAutomatedEmails() {
		this.hideAllChildComponents();
		this.addClassToItem('automatedEmailsItem');
		this.visibleAutomatedEmailsManagement = true;
	}
	public showGeneralSettings() {
		this.hideAllChildComponents();
		this.addClassToItem('generalSettingsItem');
		this.visibleGeneralSettings = true;
	}	
	public showEmailSettings() {
		this.hideAllChildComponents();
		this.addClassToItem('emailSettingsItem');
		this.visibleEmailSettings = true;
	}
	public showQualificationsMAsterManagement() {
		this.hideAllChildComponents();
		this.addClassToItem('qualificationsMasterItem');
		this.visibleQualificationsMasterManagement = true;
	}
	public showRelationshipTypesManagement() {
		this.hideAllChildComponents();
		this.addClassToItem('relationshipTypesItem');
		this.visibleRelationshipTypesManagement = true;
	}
	public shoSecurityTargetsDefinitions() {
		this.hideAllChildComponents();
		this.addClassToItem('securityTargetsItem');
		this.visibleSecurityTargetSettings = true;
	}
	public hideAllChildComponents() {
		this.visibleAgencyManagement = false;
		this.visibleSecurityGroupManagement = false;
		this.visibleUserManagement = false;

		this.visibleRequestTypeManagement = false;
		this.visibleRequestStatusManagement = false;
		this.visibleRegionsManagement = false;
		this.visibleStatusReasonsManagement = false;
		this.visibleUnitOfMeasureManagement = false;
		this.visibleNoteCategoryManagement = false;
		this.visibleDocumentCategoryManagement = false;

		this.visibleMessageDefinitionManagement = false;
		this.visibleAutomatedEmailsManagement = false;
		this.visibleQualificationsMasterManagement = false;
		this.visibleRelationshipTypesManagement = false;
		this.visibleSecurityTargetSettings = false;

		this.visibleGeneralSettings = false;
		this.visibleEmailSettings = false;

		if (this.visibleAgencyLink) {
			this.removeClassFromItems('agencyItem');
		}

		if (this.visibleUserLink) {
			this.removeClassFromItems('userItem');
		}

		if(this.visibleSecurityGroupLink) {
			this.removeClassFromItems('groupMgmtItem');
		}
		if(this.visibleRequestTypeLink) {
			this.removeClassFromItems('requestTypeItem');
		}
		if(this.visibleRequestStatusLink) {
			this.removeClassFromItems('requestStatusItem');
		}
		if(this.visibleRegionsLink) {
			this.removeClassFromItems('masterRegionsItem');
		}
		if(this.visibleStatusReasonsLink) {
			this.removeClassFromItems('statusReasonsItem');
		}
		if(this.visibleUnitOfMeasureLink) {
			this.removeClassFromItems('unitOfMeasureItem');
		}
		if(this.visibleNoteCategoryLink) {
			this.removeClassFromItems('noteCategoryItem');
		}

		if(this.visibleDocumentCategoryLink) {
			this.removeClassFromItems('documentCategoryItem');
		}
		if(this.visibleMessageDefinitionLink) {
			this.removeClassFromItems('messageDefinitionItem');
		}
		if(this.visibleAutomatedEmailsLink) {
			this.removeClassFromItems('automatedEmailsItem');
		}
		if (this.visibleEmailLink) {
			this.removeClassFromItems('emailSettingsItem');
		}
		
		if (this.visibleSecurityTargetLink) {
			this.removeClassFromItems('securityTargetsItem');
		}

		if (this.visibleGeneralLink) {
			this.removeClassFromItems('generalSettingsItem');
		}
		
		if (this.visibleQualificationsMasterLink) {
			this.removeClassFromItems('qualificationsMasterItem');
		}
		if(this.visibleRelationshipTypesMasterLink) {
			this.removeClassFromItems('relationshipTypesItem');
		}
	}

	public removeClassFromItems(itemId: string): void {
		if (document.getElementById(itemId).classList.contains('selectedMenuItem') === true)
			document.getElementById(itemId).classList.remove('selectedMenuItem');

	}
	public addClassToItem(itemId: string): void {
		document.getElementById(itemId).classList.add('selectedMenuItem');
	}

}

